import React from 'react';
import ReactDOM from 'react-dom';
import { FaCheckCircle } from 'react-icons/fa';

export default function ModalSuccess({ visible, onClose }) {
    if (!visible) return null;

    const backdropStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000
    };

    const modalStyle = {
        background: '#fff',
        padding: '1.5rem',
        borderRadius: '0.5rem',
        textAlign: 'center',
        maxWidth: '400px',
        width: '90%'
    };

    const iconStyle = {
        color: '#28a745',
        marginBottom: '1rem'
    };

    const buttonStyle = {
        marginTop: '1rem',
        padding: '0.5rem 1rem',
        border: 'none',
        borderRadius: '0.25rem',
        background: '#28a745',
        color: '#fff',
        cursor: 'pointer'
    };

    return ReactDOM.createPortal(
        <div style={backdropStyle}>
            <div style={modalStyle}>
                <FaCheckCircle style={iconStyle} size={64} />
                <h2>Vinculación enviada correctamente</h2>
                <button style={buttonStyle} onClick={onClose}>
                    Aceptar
                </button>
            </div>
        </div>,
        document.getElementById('modal-root')
    );
}
